import { useCallback } from 'react';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import type { Hit as AlgoliaHit } from 'instantsearch.js';
import type { AlgoliaProductAttributes } from '../../AlgoliaProductAttributes';
import { useAnalyticsProvider } from './useAnalyticsProvider';

export function useProductTracking() {
    const { trackProductInteraction, trackViewItemList } = useAnalyticsProvider();

    const createEnhancedSendEvent = useCallback(
        (originalSendEvent: SendEventForHits) => {
            return (
                eventType: string,
                hit: AlgoliaHit<AlgoliaProductAttributes>,
                label?: string
            ) => {
                originalSendEvent(eventType, hit, label);
                trackProductInteraction(hit, eventType, label);
            };
        },
        [trackProductInteraction]
    );

    const trackItemList = useCallback(
        (items: AlgoliaHit<AlgoliaProductAttributes>[], isSearch = false, delay = 0) => {
            if (delay > 0) {
                setTimeout(() => trackViewItemList(items, isSearch), delay);
            } else {
                trackViewItemList(items, isSearch);
            }
        },
        [trackViewItemList]
    );

    return {
        createEnhancedSendEvent,
        trackItemList,
        trackProductInteraction,
        trackViewItemList
    };
}